export const API_BASE = import.meta.env.VITE_API_BASE ?? '';

export const LOGIN_ENDPOINT = '/api/customers/auth/login';
export const REGISTER_ENDPOINT = '/api/customers/auth/register';
export const CUSTOMER_SESSION_ENDPOINT = '/api/customers/auth/session';
export const CUSTOMER_REFRESH_ENDPOINT = '/api/customers/auth/refresh';

const config = {
  API_BASE,
  LOGIN_ENDPOINT,
  REGISTER_ENDPOINT,
  CUSTOMER_SESSION_ENDPOINT,
  CUSTOMER_REFRESH_ENDPOINT,
};
export default config;
